module.exports = function killEvent(e) {
  if (e && e.stopPropagation) {
    e.stopPropagation()
  }
  if (e && e.preventDefault) {
    e.preventDefault()
  }
}
